import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { routes } from '../../constants/routes';

export default function AdminRouter() {
  const isAdmin = true;

  return isAdmin ? <Outlet /> : <Navigate to={routes.home} />;
}